/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import GuideCharacter from '@assets/images/bg/character/first-bet-characte-02.png'
import { CharacterDialog } from '@views/Popup/Dialog/CharacterDialog'

export const UserPickNullOngoingBetInfo: React.FC = observer(() => {
  const img = <img src={GuideCharacter} alt="캐릭터" className="guide-character" loading="lazy"/>
  const title = (
    <p className="guide-txt big">
      분석대상 경기가 존재하지 않습니다.
    </p>
  )
  const body = (
    <div className="guide-box small ">
      나도승부사 분석글은 베팅한<br/>
      <span className="point-color--orange--modal">&rsquo;시작전 경기&rsquo;</span>를 대상으로 작성가능합니다.
    </div>
  )

  return (<CharacterDialog characterImg={img} title={title} body={body}/>)
})
